import React from "react";

// KPI stat card with an accent-tinted icon chip and optional trend badge.
export function StatCard({ icon: Icon, label, value, sub, accent = "#003E87", trend, onClick, testid, compact }) {
  return (
    <div
      data-testid={testid}
      onClick={onClick}
      className={`group bg-white border border-slate-200 rounded-xl shadow-sm transition-all duration-200 ${onClick ? "cursor-pointer hover:shadow-md hover:border-slate-300 hover:-translate-y-0.5" : ""} ${compact ? "p-4" : "p-5"}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[11px] uppercase tracking-wider text-slate-400">{label}</div>
          <div className={`font-mono font-bold text-slate-900 tabular-nums mt-1 leading-none ${compact ? "text-2xl" : "text-3xl"}`}>{value}</div>
          {sub && <div className="text-[11px] text-slate-400 mt-1.5 truncate">{sub}</div>}
        </div>
        {Icon && (
          <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 transition-transform group-hover:scale-105" style={{ background: `${accent}14`, color: accent }}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
      {trend && (
        <div className={`mt-3 inline-flex items-center gap-1 text-[11px] font-medium px-1.5 py-0.5 rounded-full border ${trend.dir === "down" ? "bg-rose-50 text-rose-700 border-rose-200" : "bg-emerald-50 text-emerald-700 border-emerald-200"}`}>
          {trend.text}
        </div>
      )}
    </div>
  );
}

export default StatCard;
